import { useTranslate } from '@tolgee/react';
import { useEffect } from 'react';
import SpecialOrderSection from '../../components/special-order/special-order-section/SpecialOrderSection';
import {
  useGlobalActions,
  useGlobalContext,
} from '../../global-context/GlobalContext';
import { useSetting } from '../../hooks/graphql/useGetSettings';
import useIsMobile from '../../hooks/utils/useIsMobile';
import './SpecialOrder.scss';

const SpecialOrder = () => {
  const { t } = useTranslate();
  const isMobile = useIsMobile();
  const { setCutoffHours } = useGlobalActions();
  const cutoffHours = useGlobalContext(c => c.specialOrder.cutoffHours);
  const { settings } = useSetting(['SPECIAL_ORDER_CUTOFF_HOURS']);

  useEffect(() => {
    const rawVal =
      settings.SPECIAL_ORDER_CUTOFF_HOURS ||
      settings.special_order_cutoff_hours;
    if (rawVal) {
      const parsedHours = Number(rawVal);
      if (!isNaN(parsedHours) && parsedHours > 0) {
        setCutoffHours(parsedHours);
      }
    }
  }, [settings, setCutoffHours]);

  return (
    <div className={`special-order-container ${isMobile ? 'mobile' : ''}`}>
      <div className='special-order-header'>
        <h1 className='special-order-header-heading'>
          {t('special-order-heading-1')}
        </h1>
        <h1 className='special-order-header-heading'>
          {t('special-order-heading-2')}
        </h1>
        <p className='special-order-header-subheading'>
          {t('special-order-subHeading-1')}
        </p>
        <p className='special-order-header-subheading'>
          {t('special-order-subHeading-2', { hours: cutoffHours })}
        </p>
      </div>
      <div className='special-order-section'>
        <SpecialOrderSection />
      </div>
    </div>
  );
};

export default SpecialOrder;
